import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { UserDetails } from '../../modal/user.model';
import { GraphService } from '../../services/graph-services/graph-service';


@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [MatToolbarModule, MatIconModule, MatBadgeModule, MatFormFieldModule, MatInputModule, MatButtonModule],
  templateUrl: './top-bar.html',
  styleUrl: './top-bar.scss',
})
export class TopBar implements OnInit {
  public userDetails: UserDetails | null = null;

  constructor(private readonly graphService: GraphService) { }

  ngOnInit(): void {
    this.loadUserData();
  }

   async loadUserData(): Promise<void> {
     try {
       this.userDetails = await this.graphService.getUserProfile();
     } catch (error) {
       console.error('[TopBar] Failed to load user profile', error);
       this.userDetails = null;
     }
   }
   
 }
